module.exports = __webpack_public_path__ + "static/media/plus.8c31f334.svg";